import { useAuth } from '@/context/auth';
import { needToShowOnboarding } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function AppWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // V2 setup is gated in place by PortalShell using /users/onboarding.
    // The legacy profile predicate still requires specialities, which V2
    // doctors can choose after setup. Applying it here traps those doctors
    // on /portal/link and prevents access to Settings and Specialities.
    if (import.meta.env.VITE_CLINICIAN_EXPERIENCE_V2_ENABLED === 'true') {
      return;
    }

    // Issue #307 regression, fixed 2026-08-20: this used to target
    // /dashboard, back when /dashboard itself hosted the onboarding wizard.
    // /dashboard is now a pure redirect to a persona's /portal/* landing
    // tab (DashboardRedirect) — forcing this effect's target back to
    // /dashboard fought that redirect and left the app permanently stuck
    // there rendering nothing. /portal/link is always valid here: this
    // effect only ever fires for a persona with a doctorProfile
    // (needToShowOnboarding's own first check returns false without one),
    // and PortalShell gates onboarding for every /portal/* route alike.
    if (user) {
      if (needToShowOnboarding(user)) {
        navigate('/portal/link', { replace: true });
      }
    }
  }, [navigate, user]);

  return <>{children}</>;
}
